/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification Verified Icon component.
 */
export const NotificationVerifiedFilledIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12.5' cy='11.5' r='9.5' fill={iconColor} />
      <path d='M16.1604 8.53478L10.583 13.9084L7.74461 11.1738C7.46673 10.906 7.01021 10.906 6.73234 11.1738C6.45446 11.4415 6.45446 11.8813 6.73234 12.149L10.0669 15.3617C10.2058 15.4956 10.3845 15.5721 10.583 15.5721C10.7814 15.5721 10.9601 15.4956 11.099 15.3617L17.1727 9.51005C17.4505 9.24233 17.4505 8.8025 17.1727 8.53478C16.8948 8.26705 16.4581 8.26705 16.1604 8.53478Z' fill={dlsColor('white')} />
    </svg>
  );
};

export default NotificationVerifiedFilledIcon;
